import SubHeader from "../../components/header/SubHeader";
import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit, reverseEnum} from "../../components/Utility";
import {fetchCustomerWithDiscountById} from "../../store/customer-discount-slice";
import Button from "../../components/common/button/Button";
import {Status} from "../../enums/enums";
import {fetchProductList} from "../../store/list-slice";
import moment from "moment-timezone";

const DiscountDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const timezone = 'Asia/Kolkata';

    const {pagination} = useSelector(state => state.discount);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const userRole = useSelector((state) => state.auth.selectedRole);
    const products = useSelector(state => state.list.product.items)

    useEffect(() => {
        dispatch(fetchCustomerWithDiscountById({...userRole, id: params.discountId}));
        dispatch(fetchProductList({...userRole, allProducts: true}))
    }, [dispatch, params.discountId, userRole]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.discount);

    const item = items.find(item => item.id === params.discountId);
    return (
        <>
            <SubHeader title="Discount Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" &&
                    <>
                        <div className="row gx-5">
                            <div className="col-12 col-lg-9 col-xl-7">
                                <dl className="card-dl d-flex">
                                    <dt className="fs-sm fw-medium opacity-75 col-5">Customer</dt>
                                    <dd className="fs-sm fw-semibold text-break mb-0 col">
                                        {item.customer.lName
                                            ? `${item.customer.fName} ${item.customer.lName}`
                                            : item.customer.fName}
                                    </dd>
                                </dl>
                                {item.maximumDiscount !== undefined && item.maximumDiscount !== null && (
                                    <dl className="card-dl d-flex">
                                        <dt className="fs-sm fw-medium opacity-75 col-5">Maximum Discount</dt>
                                        <dd className="fs-sm fw-semibold text-break mb-0 col">
                                            {item.maximumDiscount}
                                        </dd>
                                    </dl>)}
                                {item.startDate && <dl className="card-dl d-flex">
                                    <dt className="fs-sm fw-medium opacity-75 col-5">Start Date</dt>
                                    <dd className="fs-sm fw-semibold text-break mb-0 col">
                                        {moment(item.startDate).tz(timezone).format('MMM DD, YYYY, hh:mm A')}
                                    </dd>
                                </dl>}
                                {item.endDate && <dl className="card-dl d-flex">
                                    <dt className="fs-sm fw-medium opacity-75 col-5">End Date</dt>
                                    <dd className="fs-sm fw-semibold text-break mb-0 col">
                                        {moment(item.endDate).tz(timezone).format('MMM DD, YYYY, hh:mm A')}
                                    </dd>
                                </dl>}
                                <dl className="card-dl d-flex">
                                    <dt className="fs-sm fw-medium opacity-75 col-5">Status</dt>
                                    <dd className="fs-sm fw-semibold text-break mb-0 col">
                                        {reverseEnum(Status)[item.status]}
                                    </dd>
                                </dl>
                                {item.isAllProducts && <>
                                    <dl className="card-dl d-flex">
                                        <dt className="fs-sm fw-medium opacity-75 col-5">Discount Type</dt>
                                        <dd className="fs-sm fw-semibold text-break mb-0 col">
                                            {item.discountType}
                                        </dd>
                                    </dl>
                                    <dl className="card-dl d-flex">
                                        <dt className="fs-sm fw-medium opacity-75 col-5">Discount</dt>
                                        <dd className="fs-sm fw-semibold text-break mb-0 col">
                                            {item.discountType === "Percentage"
                                                ? `${item.discount}%`
                                                : ` ₹${item.discount}/-`}
                                        </dd>
                                    </dl>
                                </>}
                            </div>
                        </div>
                        {(!item.isAllProducts) &&
                            <>
                                <h6 className="mt-4">Discount by Item</h6>
                                <table className="table table-sm fs-md mobile-responsive">
                                    <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Product discount type</th>
                                        <th>Discount amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {item.products.map((product, index) => (
                                        <tr key={index}>
                                            <td>{products[product.productId]}</td>
                                            <td>{product.productDiscountType}</td>
                                            <td>
                                                {product.productDiscountType === "Percentage"
                                                    ? `${product.discountAmount}%`
                                                    : `₹ ${product.discountAmount}/-`}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </>}
                    </>}
            </div>
        </>
    )
}

export default DiscountDetail;